const DROPDOWN_TYPE = {
  Add: 'add',
  Exists: 'exists',
  Disabled: 'disabled',
};

export default DROPDOWN_TYPE;
